import { Tag } from '@jouzen/ecom-components/v3/Tag';
import { useTranslations } from 'next-intl';
import type { MouseEvent } from 'react';

import { EventType } from '@/analytics/types';
import {
  ARTICLE_CARDS,
  ARTICLE_IMAGE,
} from '@/app/[locale]/membership/_data/AppUpdatesData';
import ArticleCardsModule from '@/app/components/ArticleCardsModule';

const AppUpdatesSection = () => {
  const t = useTranslations();

  const handleLinkClick = async (
    event: MouseEvent<HTMLAnchorElement>,
  ): Promise<void> => {
    const { href } = event.currentTarget;
    const siteName = event.currentTarget.dataset['siteName'];
    await window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: siteName,
      location: 'body',
      path: href,
    });
  };

  return (
    <div className="pt-10 md:pt-20">
      <ArticleCardsModule
        articleCards={ARTICLE_CARDS}
        articleImage={ARTICLE_IMAGE}
        eyebrowText="membership_recent_app_title"
        eyebrowTextColor="light"
        mobileSliderAriaLabels={[
          t('go_to_fuel_aria_label'),
          t('go_to_stress_aria_label'),
          t('go_to_health_aria_label'),
        ]}
        onClick={handleLinkClick}
        swipeableDotsProps={{
          activeColor: 'sandstone-200',
          color: 'sandstone-500',
        }}
        wrapperClass="bg-slate-200"
        imageTag={() => (
          <div>
            <Tag variant="lightSandstone" size="small">
              {t('membership_women_health_card_tag')}
            </Tag>
          </div>
        )}
      />
    </div>
  );
};

export default AppUpdatesSection;
